module.exports = __webpack_public_path__ + "img/grey-abstract.a2fface3.jpg";